import {Component, Input} from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  standalone: true,
  imports: [MaterialModule, FormsModule, CommonModule]
})
export class DescriptionComponent {
  @Input() marketReferenceData: any[];
  @Input() layout2col = true;
  @Input() index: any;
}
